// extracted by mini-css-extract-plugin
export const products = "products-module--products--rEbqU";
export const buy = "products-module--buy--2f5qR";
export const nameWrapper = "products-module--name-wrapper--1GG9s";
export const name = "products-module--name--3rSrW";
export const brand = "products-module--brand--2UDhc";
export const price = "products-module--price--2WOkG";
export const tax = "products-module--tax--2Owmw";